/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_RECORDINGS_STATUS_DETAILS = 'SET_RECORDINGS_STATUS_DETAILS';
